import React, { useState, useEffect } from "react";

import InvoiceTop from "./InvoiceTop";
import InvoiceTable from "./InvoiceTable";
import InvoiceFilters from "./InvoiceFilters";
import InvoiceHeader from "./InvoiceHeader";

import { useNavigate } from "react-router-dom";

import "./styles/Invoice.css";
import API from "./services/api";
export default function Invoice() {

  const navigate = useNavigate();

  /* ================= ROWS ================= */
  const [rows,setRows]=useState([]);
  const [backupRows, setBackupRows] =
    useState({});

  /* ================= INVOICE INFO ================= */

  const [invoiceInfo, setInvoiceInfo] =
    useState(() => {

      const saved =
        JSON.parse(
          localStorage.getItem("invoiceInfo") || "{}"
        );

      return {

        billTo:
          saved.billTo || "",

        customerId:
          saved.customerId ||
          "CUST-" + Math.floor(Math.random() * 10000),

        panId:
          saved.panId || "",

        date:
          saved.date || "",

        address: {

          homeNo:
            saved.address?.homeNo || "",

          street:
            saved.address?.street || "",

          city:
            saved.address?.city || "",

          pincode:
            saved.address?.pincode || "",

          state:
            saved.address?.state || ""

        }

      };

    });

  const [isEditingTop, setIsEditingTop] =
    useState(false);

  /* ================= FILTER STATES ================= */

  const [searchText, setSearchText] =
    useState("");

  const [filterMonth, setFilterMonth] =
    useState("");

  const [filterYear, setFilterYear] =
    useState("");

  /* ================= SAVE LOCAL STORAGE ================= */

  useEffect(() => {

    localStorage.setItem(
      "invoiceInfo",
      JSON.stringify(invoiceInfo)
    );

  }, [invoiceInfo]);

  useEffect(()=>{

fetchInvoices();

},[]);
const fetchInvoices=async()=>{

try{

const res=await API.get("/expense");

setRows(
res.data.map(item=>({
...item,
isEditing:false
}))
);

}catch(err){

console.log(err);

}

};
  /* ================= GENERATE BILL ================= */

  const generateBill = () => {

    navigate("/bill", {
      state: {
        rows,
        invoiceInfo
      }
    });

  };

  /* ================= TOP HANDLERS ================= */

  const handleInfoChange =
    (field, value) => {

      setInvoiceInfo(prev => ({
        ...prev,
        [field]: value
      }));

    };

  const handleTopEdit =
    () => setIsEditingTop(true);

  const handleTopSave =
    () => setIsEditingTop(false);

  const handleTopCancel =
    () => setIsEditingTop(false);

  /* ================= ADD ROW ================= */

  const addRow = () => {

    setRows([

      ...rows,

      {

        id: Date.now(),

        invoiceNo:
          rows.length + 1001,

        customerName: "",

        subItems: [

          {

            date: "",

            category: "",

            description: "",

            quantity: 0,

            amount: 0,

            total: 0

          }

        ],

        isEditing: true

      }

    ]);

  };

  /* ================= MAIN CHANGE ================= */

  const handleChange =
    (id, field, value) => {

      setRows(

        rows.map(r => {

          if (r.id === id) {

            return {
              ...r,
              [field]: value
            };

          }

          return r;

        })

      );

    };

  /* ================= SUB CHANGE ================= */

  const handleSubChange =
    (id, index, field, value) => {

      setRows(

        rows.map(r => {

          if (r.id === id) {

            const updatedSubItems =
              (r.subItems || []).map((item, i) => {

                if (i === index) {

                  let updated = {
                    ...item,
                    [field]: value
                  };

                  const qty =
                    field === "quantity"
                      ? value
                      : item.quantity;

                  const amt =
                    field === "amount"
                      ? value
                      : item.amount;

                  updated.total =
                    (parseFloat(qty) || 0) *
                    (parseFloat(amt) || 0);

                  return updated;

                }

                return item;

              });

            return {
              ...r,
              subItems: updatedSubItems
            };

          }

          return r;

        })

      );

    };

  /* ================= ADD SUB ITEM ================= */

  const addSubItem = (id) => {

    setRows(

      rows.map(r => {

        if (r.id === id) {

          return {

            ...r,

            subItems: [

              ...(r.subItems || []),

              {

                date: "",

                category: "",

                description: "",

                quantity: 0,

                amount: 0,

                total: 0

              }

            ]

          };

        }

        return r;

      })

    );

  };

  /* ================= DELETE SUB ITEM ================= */

  const deleteSubItem =
    (id, index) => {

      setRows(

        rows
          .map(r => {

            if (r.id === id) {

              const updated =
                (r.subItems || []).filter(
                  (_, i) => i !== index
                );

              if (updated.length === 0)
                return null;

              return {
                ...r,
                subItems: updated
              };

            }

            return r;

          })
          .filter(Boolean)

      );

    };

  /* ================= EDIT ================= */

  const handleEdit = id => {

    setBackupRows(prev => ({

      ...prev,

      [id]:
        rows.find(r => r.id === id)

    }));

    setRows(

      rows.map(r =>

        r.id === id
          ? {
              ...r,
              isEditing: true
            }
          : r

      )

    );

  };

  /* ================= SAVE ================= */

  const handleSave = async (id) => {

    try {

      const row =
        rows.find(r => r.id === id);

      const totalAmount =
        (row.subItems || []).reduce(

          (sum, item) =>
            sum + Number(item.total || 0),

          0

        );

      const payload = {

        employeeName:
          row.customerName,

        description:
          (row.subItems || [])
            .map(i => i.description)
            .join(", "),

        amount:
          totalAmount,

        invoiceNo:
          row.invoiceNo,

        customerName:
          row.customerName,

        subItems:
          row.subItems

      };

      await API.post(
"/invoice/create",
payload
);

fetchInvoices();
      setRows(

        rows.map(r =>

          r.id === id
            ? {
                ...r,
                isEditing: false
              }
            : r

        )

      );

      alert("Invoice Saved");

    } catch (err) {

      console.log(err);

      alert("Error Saving Invoice");

    }

  };

  /* ================= CANCEL ================= */

  const handleCancel = id => {

    setRows(

      rows.map(r =>

        r.id === id
          ? {
              ...backupRows[id],
              isEditing: false
            }
          : r

      )

    );

  };

  /* ================= DELETE ROW ================= */

  const deleteRow = id => {

    setRows(
      rows.filter(r => r.id !== id)
    );

  };

  /* ================= FILTER ================= */

  const filteredRows = rows.filter((r) => {

    const customer =
      (r.customerName || "")
        .toLowerCase();

    const search =
      searchText.toLowerCase();

    const searchMatch =
      customer.includes(search);

    const subItems =
      Array.isArray(r.subItems)
        ? r.subItems
        : [];

    // NO FILTER

    if (!filterMonth && !filterYear) {

      return searchMatch;

    }

    // MONTH + YEAR FILTER

    const hasMatchingDate =
      subItems.some((item) => {

        if (!item.date) return false;

        const itemDate =
          new Date(item.date);

        if (
          isNaN(itemDate.getTime())
        ) {
          return false;
        }

        const month =
          String(
            itemDate.getMonth() + 1
          ).padStart(2, "0");

        const year =
          String(
            itemDate.getFullYear()
          );

        const monthMatch =

          !filterMonth ||

          month === filterMonth;

        const yearMatch =

          !filterYear ||

          year === filterYear;

        return (
          monthMatch &&
          yearMatch
        );

      });

    return (
      searchMatch &&
      hasMatchingDate
    );

  });

  /* ================= UI ================= */

  return (

    <div className="invoice-container">

      <InvoiceHeader />

      <InvoiceTop

        invoiceInfo={invoiceInfo}

        isEditingTop={isEditingTop}

        handleTopEdit={handleTopEdit}

        handleTopSave={handleTopSave}

        handleTopCancel={handleTopCancel}

        handleInfoChange={handleInfoChange}

      />

      <InvoiceFilters

        searchText={searchText}

        setSearchText={setSearchText}

        filterMonth={filterMonth}

        setFilterMonth={setFilterMonth}

        filterYear={filterYear}

        setFilterYear={setFilterYear}

        addRow={addRow}

      />

      <InvoiceTable

        rows={filteredRows}

        handleChange={handleChange}

        handleEdit={handleEdit}

        handleSave={handleSave}

        handleCancel={handleCancel}

        deleteRow={deleteRow}

        addSubItem={addSubItem}

        handleSubChange={handleSubChange}

        deleteSubItem={deleteSubItem}

      />

      <div
        style={{
          marginTop: "20px",
          textAlign: "right"
        }}
      >

        <button
          onClick={generateBill}
        >
          Generate Bill
        </button>

      </div>

    </div>

  );

}